var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ti_bg",style:({ 'height': _vm.hasKpi ? '14px' : '100px'})})
}
var staticRenderFns = []

export { render, staticRenderFns }